import {
  AVAILABILITY_SUMMARY,
  FETCH_CALCULATED_PRICE_FAILURE,
  FETCH_CALCULATED_PRICE_REQUEST,
  FETCH_CALCULATED_PRICE_SUCCESS,
  RESERVATION_DETAILS,
  RESERVATION_FAILED_REQUEST,
  RESERVATION_LIST_DATA,
  RESERVATION_PRICING_LIST,
  RESERVATION_REQUEST,
  RESERVATION_REQUEST_FAILED,
  RES_LOCATION_LIST,
  SAVE_RESERVATION_STATE_DATA,
  UPDATE_RESERVATION_CHECKOUT,
  SET_SELECTED_RESERVATION_DETAILS,
  LOCATION_GATE_LIST_DATA,
  FETCH_GATELIST_REQUEST_FAILED,
  SET_SELECTED_GATES,
  SPOT_THRESHOLD,
} from "../constants";

const INITIAL_STATE = {
  locationData: [],
  pricingList: [],
  reservationData: {},
  isLoading: false,
  reservationCheckoutData: {},
  availabilitySummaryData: [],
  spotThreshold: {},
  reservationList: [],
  reservationDetails: {},
  calculatedPricingData: {},
  reservationStateData: {},
  selectedReservation: {},
  gateList: [],
  selectedGates: [],
};

const reservationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESERVATION_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RESERVATION_FAILED_REQUEST:
      return INITIAL_STATE;
    case RES_LOCATION_LIST:
      return {
        ...state,
        locationData: action.payload,
        isLoading: false,
      };
    case RESERVATION_PRICING_LIST:
      return {
        pricingList: action.payload,
        isLoading: false,
      };
    case RESERVATION_REQUEST_FAILED:
      return {
        ...state,
        reservationList: action.payload,
        isLoading: false,
      };
    case UPDATE_RESERVATION_CHECKOUT:
      return {
        ...state,
        reservationCheckoutData: action.payload,
        isLoading: false,
      };
    case AVAILABILITY_SUMMARY:
      return {
        ...state,
        availabilitySummaryData: action.payload,
        isLoading: false,
      };
    case SPOT_THRESHOLD:
      return {
        ...state,
        spotThreshold: action.payload,
        isLoading: false,
      };
    case RESERVATION_LIST_DATA:
      return {
        ...state,
        reservationList: action.payload,
        isLoading: false,
      };
    case RESERVATION_DETAILS:
      return {
        ...state,
        reservationDetails: action.payload,
        isLoading: false,
      };
    case FETCH_CALCULATED_PRICE_REQUEST:
      return {
        ...state,
        calculatedPricingData: {},
        isLoading: true,
      };
    case FETCH_CALCULATED_PRICE_SUCCESS:
      return {
        ...state,
        calculatedPricingData: action.payload,
        isLoading: false,
      };
    case FETCH_CALCULATED_PRICE_FAILURE:
      return {
        ...state,
        calculatedPricingData: {},
        isLoading: false,
      };
    case SAVE_RESERVATION_STATE_DATA:
      return {
        ...state,
        reservationStateData: action.payload,
      };
    case SET_SELECTED_RESERVATION_DETAILS:
      return {
        ...state,
        isLoading: false,
        selectedReservation: action.payload,
      };
    case LOCATION_GATE_LIST_DATA:
      return {
        ...state,
        gateList: action.payload,
        isLoading: false,
      };
    case FETCH_GATELIST_REQUEST_FAILED:
      return {
        ...state,
        gateList: action.payload,
        isLoading: false,
      };
    case SET_SELECTED_GATES:
      return {
        ...state,
        isLoading: false,
        selectedGates: action.payload,
      };
    default:
      return state;
  }
};

export default reservationReducer;
